import React from "react";
import './textBox/TextBox.module.scss';
import IField from "../../models/view/common/IField";
import TextBox, {TextBoxAutoCompleteValue, TextBoxInputModeValue} from "./textBox/TextBox";

export interface IFormFieldTextInputProps<TValue>{
  autoCapitalize?: "on" | "off";
  autoComplete?: TextBoxAutoCompleteValue;
  disabled?: boolean;
  formField: IField<TValue>,
  inputMode?: TextBoxInputModeValue;
  isEmail?: boolean;
  isPassword?: boolean;
  isRequired?: boolean;
  label?: string;
  note?: string,
  placeHolder?: string;
}

export function FormFieldTextInput({
  autoCapitalize,
  autoComplete,
  disabled,
  formField,
  inputMode,
  isEmail,
  isPassword,
  isRequired,
  label,
  note,
  placeHolder,
}: IFormFieldTextInputProps<string>){
  const h = formField.use();
  return <TextBox
    autoCapitalize={autoCapitalize === "on"}
    autoComplete={autoComplete}
    disabled={disabled}
    errorMessages={h.error.errorMessages}
    inputMode={inputMode}
    isEmail={isEmail}
    isErrorState={h.error.isInErrorState}
    isPassword={isPassword}
    isRequired={isRequired}
    label={label}
    note={note}
    onBlur={h.onBlur}
    onChange={h.setValue}
    placeHolder={placeHolder}
    value={h.value}
  />;
}